<template>
  <ScreenWidthProvider
    v-slot="{ isWider }"
    class="hotel-preview-swiper-gallery"
  >
    <div
      ref="featuredImage"
      class="hotel-preview-swiper-gallery__image"
      :class="{ clickable: clickableGallery }"
      @click="clickableGallery && $emit('open-gallery')"
    >
      <Swiper
        class="size-full"
        arrows-align="border"
        arrows-type="circular"
        :pagination="false"
        :arrow-shadow="true"
        only-render-visible-slides
        prevent-swiper-update
        loop
        :loading-skeleton-aspect="false"
      >
        <div
          v-for="(image, index) in hotelFeaturedImg"
          :key="`slide_${index}`"
          class="flex justify-center size-full"
        >
          <LazyMultiVideoPlayer
            v-if="image[index]?.type === 'youtube'"
            :movies="image"
            is-hotel-gallery
          />
          <ResponsiveHotelImage
            v-else
            :image="image"
            :alt="`Slide ${index + 1}`"
          />
        </div>
      </Swiper>
    </div>
    <HotelPreviewGalleryThumbnails
      v-if="isWider('md')"
      class="grid hotel-gallery-lg"
      :thumbnail-images="images.slice(2, 4)"
      :total-images="images.length"
      :hotel-layout="isHotel"
      @open-gallery="$emit('open-gallery')"
    />
    <HotelPreviewGalleryThumbnails
      v-else
      class="grid hotel-gallery-sm"
      :thumbnail-images="images.slice(1,2 )"
      :total-images="images.length"
      :hotel-layout="isHotel"
      @open-gallery="$emit('open-gallery')"
    />
  </ScreenWidthProvider>
</template>

<script>
import charterHotelMixin from '@layers/web/mixins/charter-hotel.mixin.js'

export default defineNuxtComponent({
  setup () {
    const { public: { images: imagesConfig } } = useRuntimeConfig()

    return {
      imagesConfig,
    }
  },

  name: 'HotelPreviewSwiperGallery',

  mixins: [charterHotelMixin],

  props: {
    hotel: {
      type: Object,
      required: true,
    },

    clickableGallery: {
      type: Boolean,
      default: false,
    },

    isHotel: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      failed: false,
    }
  },

  emits: ['open-gallery'],

  computed: {

    hotelFeaturedImg () {
      if (!this.images?.length) {
        return ''
      } else if (this.failed) {
        return this.imagesConfig.fallbackImage
      }

      const imagesClone = this.images.slice(1)
      const images = [...imagesClone]

      if (this.hotel?.movies?.length > 0 || this.hotel?.meta?.movies?.length > 0) {
        images.unshift(this.hotel?.movies || this.hotel?.meta?.movies)
      }

      return images
    },
  },
})
</script>
